import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "top-selling-products-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content position-relative" }
const _hoisted_4 = { class: "product-item" }
const _hoisted_5 = { class: "content d-flex justify-content-between" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "fw-semibold" }
const _hoisted_8 = { class: "price d-block fw-semibold" }
const _hoisted_9 = { class: "sold" }
const _hoisted_10 = { class: "trezo-badge shipped" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-30\" data-v-1205fa88><h5 class=\"mb-0\" data-v-1205fa88>Top Selling Products</h5><select class=\"form-select month-select bg-gray border-0 form-control\" aria-label=\"Default select example\" data-v-1205fa88><option value=\"This Day\" data-v-1205fa88>This Day</option><option value=\"This Week\" data-v-1205fa88>This Week</option><option value=\"This Month\" data-v-1205fa88>This Month</option><option value=\"This Year\" data-v-1205fa88>This Year</option></select></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Swiper, {
          slidesPerView: 1,
          spaceBetween: 25,
          centeredSlides: false,
          preventClicks: true,
          loop: true,
          autoplay: {
            delay: 8000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          navigation: {
            prevEl: '.prev',
            nextEl: '.next',
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
            },
            506: {
              slidesPerView: 2,
            },
            668: {
              slidesPerView: 3,
            },
            705: {
              slidesPerView: 4,
            },
          },
          modules: _ctx.modules,
          class: "product-slider"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
              return (_openBlock(), _createBlock(_component_SwiperSlide, {
                key: product.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_RouterLink, {
                      to: "/ecommerce/product-details/",
                      class: "image d-block border-radius",
                      style: _normalizeStyle({ backgroundImage: `url(${product.image})` })
                    }, null, 8, ["style"]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("h6", _hoisted_7, [
                          _createVNode(_component_RouterLink, {
                            to: "/ecommerce/product-details/",
                            class: "text-black"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(product.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("span", _hoisted_8, " $" + _toDisplayString(product.price), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(product.sold), 1),
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "d-block" }, " sold ", -1))
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["modules"]),
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"product-controller\" data-v-1205fa88><div class=\"controller-icon prev\" data-v-1205fa88><i class=\"ri-arrow-left-line\" data-v-1205fa88></i></div><div class=\"controller-icon next\" data-v-1205fa88><i class=\"ri-arrow-right-line\" data-v-1205fa88></i></div></div>", 1))
      ])
    ])
  ]))
}